<template>
  <div class="material-alerts-container">
    <HeaderComp />

    <h1 class="page-heading">
      Material Alerts
    </h1>

    <div class="alerts-table">
      <table>
        <thead>
          <tr>
            <th>Component Item No</th>
            <th>Quantity Needed</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(item, index) in insufficientMaterials"
            :key="`${item.item_no}-${index}`"
          >
            <td>{{ item.item_no }}</td>
            <td>{{ item.qty_needed }}</td>
          </tr>

          <tr v-if="insufficientMaterials.length === 0">
            <td colspan="2">
              No material shortages found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import HeaderComp from './HeaderComp.vue';

export default {
  name: 'MaterialAlerts',

  components: {
    HeaderComp
  },

  data() {
    return {
      insufficientMaterials: []
    };
  },

  computed: {
    selectedLocation() {
      return (
        this.$root.selectedLocation ||
        'D'
      );
    }
  },

  watch: {
    selectedLocation() {
      this.fetchInsufficientMaterials();
    }
  },

  created() {
    this.fetchInsufficientMaterials();
  },

  methods: {
    async fetchInsufficientMaterials() {
      const loc =
        String(
          this.selectedLocation ||
          'D'
        )
          .trim()
          .toUpperCase()
          .slice(0, 1);

      try {
        const response =
          await axios.get(
            '/getInsufficientMaterials',
            {
              params: {
                location: loc
              }
            }
          );

        const rows =
          Array.isArray(response.data)
            ? response.data
            : [];

        this.insufficientMaterials =
          rows
            .map(row => {
              const qty =
                Number(row.qty_needed);

              return {
                item_no:
                  String(
                    row.item_no || ''
                  ).trim(),

                qty_needed:
                  Number.isFinite(qty)
                    ? Math.ceil(qty)
                        .toLocaleString()
                    : ''
              };
            })
            .filter(row =>
              row.item_no
            );
      } catch (error) {
        console.error(
          'Error fetching insufficient materials:',
          error.response?.data ||
          error.message
        );

        this.insufficientMaterials = [];
      }
    }
  }
};
</script>

<style scoped>
  /* Styling for the Material Alerts page */
  .material-alerts-container {
    font-family: Garamond, serif;
    text-align: center;
    color: #cbbfbf;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #0b0101;
    padding: 20px;
  }

  .page-heading {
    font-family: 'Cormorant Garamond', serif;
    font-size: 36px;
    color: #cbbfbf;
    margin-bottom: 20px;
  }

  .alerts-table {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    background-color: #0b0101;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 16px;
    background-color: #0b0101;
  }

  th, td {
    padding: 12px;
    border: 1px solid #cbbfbf;
    text-align: left;
  }

  th {
    background-color: #2c3e50;
    color: #cbbfbf;
  }

  td {
    color: #cbbfbf;
  }

  tbody tr:nth-child(even) {
    background-color: #708090a4; /* Dark slate gray-blue color for alternating rows */
  }

  tbody tr:nth-child(odd) {
    background-color: #8fbcd193; /* Light blue color from day boxes in MachinesView.vue */
  }

  tbody tr:hover {
    background-color: #f1f1f1;
  }
</style>
